module.exports = __webpack_public_path__ + "img/Image4.bde7c5f8.png";